import { render } from "./AddCustomAction.vue?vue&type=template&id=14222436&scoped=true"
import script from "./AddCustomAction.vue?vue&type=script&lang=js"
export * from "./AddCustomAction.vue?vue&type=script&lang=js"

import "./AddCustomAction.vue?vue&type=style&index=0&id=14222436&scoped=true&lang=less"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.23.0.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14222436"]])

export default __exports__